// extracted by mini-css-extract-plugin
export var buttonsWrapperDealCarousel = "TileCarousel-module--buttons-wrapper-deal-carousel--1DxoP";
export var dealCarousel = "TileCarousel-module--deal-carousel--HyjJM";
export var dealCarouselHeader = "TileCarousel-module--deal-carousel-header--vJz66";
export var pageSliceHeader = "TileCarousel-module--page-slice-header--kuhJs";
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var tabsPrefix = "TileCarousel-module--tabs-prefix--wO8sl";
export var tabsWrapper = "TileCarousel-module--tabs-wrapper--sTqeR";
export var wrapper = "TileCarousel-module--wrapper--30wPg";